<template>
  <div class="filters__switch" :class="css">
    <div class="filters__switch-track"></div>
    <div class="filters__switch-thumb-underlay">
      <div class="filters__switch-thumb">
        <input
          @click="switchHandler()"
          :id="payload.slug"
          type="checkbox"
          class="filters__switch-native-control"
          role="switch"
          :checked="payload.checked && !payload.disabled"
        />
      </div>
    </div>
    <label :for="payload.slug">
      {{ payload.name }}

      <tooltip v-if="payload.slug === 'big-five-filter'">
        ?
        <template v-slot:content>
          Shows links from companies like Google, Facebook, Instagram, Amazon, Apple, Twitter etc.
        </template>
      </tooltip>
    </label>
  </div>
</template>

<script>
import eventBus from '@/event-bus';

import Tooltip from '@/components/UI/Tooltip.vue';

export default {
  components: {
    Tooltip,
  },
  computed: {
    css() {
      return {
        'filters__switch--checked': this.payload.checked && !this.payload.disabled,
        'filters__switch--disabled': this.payload.disabled,
      };
    },
  },
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  methods: {
    switchHandler() {
      this.payload.checked = !this.payload.checked;

      if (this.payload.slug === 'domains-only') {
        eventBus.$emit('domainOnlyToggle');
      }

      if (this.payload.slug === 'spam-filter' || this.payload.slug === 'unspam-filter') {
        eventBus.$emit('spamToggle', this.payload.slug);
      }
    },
  },
  created() {
    eventBus.$on('domainOnlyToggle', () => {
      if (this.payload.slug === 'relative-filter') {
        this.payload.checked = false;
        this.payload.disabled = !this.payload.disabled;
      }
    });
  },
};
</script>
